import { useState } from 'react';
import FocusTimeDrawer from '../focusTime/FocusTimeDrawer';
import CallbackInterruptionDrawer from '../interruprions/create/callback/CallbackInterruptionDrawer';
import InterruptionsDrawer from '../interruprions/List/InterruptionsDrawer';
import AvailabilityActionButtons from './AvailabilityActionButtons';
import useEmployeePortalInterruptionsController from '../interruprions/hooks/useEmployeePortalInterruptionsController';
import { useAvailabilityCurrentUser } from '../availabilityUser/AvailabilityCurrentUserProvider';

const AvailabilityActionsSection = () => {
  const [isCallbackDrawerOpen, setIsCallbackDrawerOpen] = useState(false);
  const [isFocusTimeDrawerOpen, setIsFocusTimeDrawerOpen] = useState(false);
  const [isInterruptionsDrawerOpen, setIsInterruptionsDrawerOpen] = useState(false);
  const { isAvailabilityEnabled } = useAvailabilityCurrentUser();
  const { error, interruptionsCount, items, loading, onUpdateStatus } = useEmployeePortalInterruptionsController(
    isAvailabilityEnabled && isInterruptionsDrawerOpen,
  );

  if (!isAvailabilityEnabled) {
    return null;
  }

  const actionButtonsProps = {
    interruptionsCount,
    onExpandInterruptions: () => setIsInterruptionsDrawerOpen(true),
    onCreateInterruption: () => setIsCallbackDrawerOpen(true),
    onOpenFocusTime: () => setIsFocusTimeDrawerOpen(true),
  };

  return (
    <>
      <AvailabilityActionButtons {...actionButtonsProps} />

      <InterruptionsDrawer
        error={error}
        interruptionsCount={interruptionsCount}
        isOpen={isInterruptionsDrawerOpen}
        onClose={() => setIsInterruptionsDrawerOpen(false)}
        items={items}
        loading={loading}
        onUpdateStatus={onUpdateStatus}
      />
      <CallbackInterruptionDrawer isOpen={isCallbackDrawerOpen} onClose={() => setIsCallbackDrawerOpen(false)} />
      <FocusTimeDrawer isOpen={isFocusTimeDrawerOpen} onClose={() => setIsFocusTimeDrawerOpen(false)} />
    </>
  );
};

export default AvailabilityActionsSection;
